import React from 'react';
import styled from 'styles/styled-components';

interface Props {
  children?: object | null;
  title?: string;
  border?: boolean;
  className?: string;
}

const RibbonSection = ({ title, border, children, className }: Props) => (
  <div className="flex justify-center items-center">
    <StyledRibbonSectionWrapper border={border} className={className}>
      <div className="h-16">{children}</div>
      {title && (
        <div className="text-grey-dark text-xs self-center mt-2">{title}</div>
      )}
    </StyledRibbonSectionWrapper>
    {/*{border && <div className="h-20 border-l border-gray-400" />}*/}
  </div>
);

export default RibbonSection;

const StyledRibbonSectionWrapper = styled.div<{ border?: boolean }>`
  //"border-r border-grey px-2 mx-3 py-1"
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.4rem 0;
  //margin: 0 0 0 0.75rem;
`;
